const copy = {
    store: ['Магазин', 'Mağaza', 'Store'],
    allStores: ['Все доступные магазины', 'Bütün əlçatan mağazalar', 'All accessible stores'],
    noAllocation: [
        'Нет свободной переплаты или подтверждённых остатков для распределения.',
        'Bölüşdürmək üçün sərbəst artıq ödəniş və ya təsdiqlənmiş qalıq yoxdur.',
        'No unallocated overpayment or confirmed remaining amount is available.',
    ],
    noSalaryPreparation: [
        'Нет сотрудников без начисления за выбранный месяц с действующими условиями и валютой.',
        'Seçilmiş ay və valyuta üçün qüvvədə olan şərtlərlə hesablanmamış əməkdaş yoxdur.',
        'No employees with matching terms and currency need an accrual for this month.',
    ],
    noSalaryConfirmation: [
        'Нет доступных зарплатных черновиков за выбранный месяц и валюту.',
        'Seçilmiş ay və valyuta üçün əlçatan əməkhaqqı qaralaması yoxdur.',
        'No salary drafts are available for the selected month and currency.',
    ],
    levelThreeRequired: [
        'Для выбранных полномочий нужен финансовый уровень 3.',
        'Seçilmiş icazələr üçün maliyyə səviyyəsi 3 tələb olunur.',
        'The selected permissions require financial level 3.',
    ],
    afterCorrection: ['После исправления', 'Düzəlişdən sonra', 'After correction'],
    returned: ['Уже возвращено', 'Artıq qaytarılıb', 'Already returned'],
    returnable: ['Можно вернуть', 'Qaytarıla bilən məbləğ', 'Available to return'],
    salaryCurrencyMismatch: [
        'Действующие условия заданы в другой валюте. Выберите указанную валюту.',
        'Qüvvədə olan şərtlər başqa valyutadadır. Göstərilən valyutanı seçin.',
        'Current terms use a different currency. Choose the stated currency.',
    ],
    state: ['Состояние', 'Vəziyyət', 'State'],
    reloadAssessment: [
        'Проверить сумму и основание заново',
        'Məbləği və əsası yenidən yoxla',
        'Review amount and basis again',
    ],
    recipient: ['Получатель', 'Alan şəxs', 'Recipient'],
    forecastAmount: ['Сумма прогноза', 'Proqnoz məbləği', 'Forecast amount'],
    draftMeaning: [
        'Черновик не является подтверждённым долгом. После подготовки отдельно подтвердите сумму и начальную историю.',
        'Qaralama təsdiqlənmiş borc deyil. Hazırladıqdan sonra məbləği və başlanğıc tarixçəni ayrıca təsdiqləyin.',
        'A draft is not a confirmed debt. Confirm its amount and opening history separately after preparing it.',
    ],
    useProposal: [
        'Использовать предложенную сумму',
        'Təklif edilən məbləği istifadə et',
        'Use proposed amount',
    ],
    missingTerms: [
        'Условия зарплаты не заданы',
        'Əməkhaqqı şərtləri təyin edilməyib',
        'Salary terms are missing',
    ],
    existingMonth: [
        'Начисление за этот месяц уже есть',
        'Bu ay üçün hesablama artıq mövcuddur',
        'An accrual already exists for this month',
    ],
    reviewCalculation: [
        'Расчёт основания на момент проверки',
        'Yoxlama zamanı əsas üzrə hesablanma',
        'Basis calculation at the time of review',
    ],
    restrictedSettlement: [
        'Расчёт оплаты недоступен с текущими правами.',
        'Ödəniş hesablanması cari icazələrlə əlçatan deyil.',
        'Payment settlement is unavailable with your current permissions.',
    ],
    copyNextMonth: [
        'Создать начисление за следующий месяц',
        'Növbəti ay üçün hesablama yarat',
        'Create an accrual for next month',
    ],
    afterAllocation: ['После распределения', 'Bölüşdürmədən sonra', 'After allocation'],
    management: ['Управление', 'İdarəetmə', 'Management'],
    accruals: ['Начисления', 'Hesablamalar', 'Accruals'],
    staffing: ['Штатка', 'Ştat cədvəli', 'Staffing'],
    employees: ['Сотрудники', 'Əməkdaşlar', 'Employees'],
    positions: ['Должности', 'Vəzifələr', 'Positions'],
    counterparties: ['Контрагенты', 'Kontragentlər', 'Counterparties'],
    payableList: ['Начисления к оплате', 'Ödəniləcək hesablamalar', 'Payable accruals'],
    newPosition: ['Создать должность', 'Vəzifə yarat', 'Create position'],
    newEmployee: ['Создать сотрудника', 'Əməkdaş yarat', 'Create employee'],
    newCounterparty: ['Создать контрагента', 'Kontragent yarat', 'Create counterparty'],
    newPayable: ['Создать начисление', 'Hesablama yarat', 'Create accrual'],
    prepareSalary: [
        'Подготовить зарплату за месяц',
        'Ay üçün əməkhaqqı hazırla',
        'Prepare monthly salary',
    ],
    position: ['Должность', 'Vəzifə', 'Position'],
    monthlyAmount: ['Месячная сумма к выдаче', 'Aylıq ödəniləcək məbləğ', 'Monthly amount to pay'],
    effectiveMonth: ['Действует с месяца', 'Qüvvədə olduğu ilk ay', 'Effective month'],
    salaryMonth: ['Месяц зарплаты', 'Əməkhaqqı ayı', 'Salary month'],
    month: ['Месяц', 'Ay', 'Month'],
    currency: ['Валюта', 'Valyuta', 'Currency'],
    source: ['Источник / документ', 'Mənbə / sənəd', 'Source / document'],
    reason: ['Причина', 'Səbəb', 'Reason'],
    basis: ['Основание', 'Əsas', 'Basis'],
    basisTitle: ['Описание основания', 'Əsasın təsviri', 'Basis description'],
    basisKind: ['Вид начисления', 'Hesablama növü', 'Accrual kind'],
    salary: ['Зарплата', 'Əməkhaqqı', 'Salary'],
    general: ['Хозяйственные расходы', 'Təsərrüfat xərcləri', 'General expense'],
    counterparty: ['Контрагент', 'Kontragent', 'Counterparty'],
    linkedUser: [
        'Связать с пользователем приложения',
        'Tətbiq istifadəçisi ilə əlaqələndir',
        'Link app user',
    ],
    noUserLink: [
        'Без связи с пользователем',
        'İstifadəçi ilə əlaqələndirilməyib',
        'No app user link',
    ],
    positionProposal: [
        'Предложено по должности',
        'Vəzifəyə görə təklif edilir',
        'Proposed by position',
    ],
    noGrantFromEmployee: [
        'Сотрудник не получает логин или финансовые права. Они назначаются отдельно пользователю приложения.',
        'Əməkdaşa giriş və ya maliyyə icazələri verilmir. Bunlar tətbiq istifadəçisinə ayrıca təyin edilir.',
        'Creating an employee does not create a login or financial permissions. Those are assigned separately to an app user.',
    ],
    editTerms: ['Изменить условия', 'Şərtləri dəyiş', 'Change terms'],
    newTerms: ['Сохранить новые условия', 'Yeni şərtləri saxla', 'Save new terms'],
    archive: ['Архивировать', 'Arxivlə', 'Archive'],
    active: ['Активные', 'Aktiv', 'Active'],
    archived: ['Архивные', 'Arxivdə', 'Archived'],
    archiveMeaning: [
        'Новые автоматические начисления прекращаются. История, прежние начисления и выплаты сохраняются.',
        'Yeni avtomatik hesablamalar dayandırılır. Tarixçə, əvvəlki hesablamalar və ödənişlər saxlanılır.',
        'New automatic accruals stop. History, existing accruals and payments remain.',
    ],
    draft: ['Черновик', 'Qaralama', 'Draft'],
    confirmed: ['Подтверждено', 'Təsdiqlənib', 'Confirmed'],
    cancelled: ['Отменено', 'Ləğv edilib', 'Cancelled'],
    saveDraft: ['Сохранить черновик', 'Qaralamanı saxla', 'Save draft'],
    draftSaved: [
        'Черновик сохранён. Деньги не изменены.',
        'Qaralama saxlanıldı. Pul qalığı dəyişmədi.',
        'Draft saved. Money has not changed.',
    ],
    nonMoney: [
        'Деньги кассы не изменятся.',
        'Kassanın pul qalığı dəyişməyəcək.',
        'Cash balances will not change.',
    ],
    pay: ['Оплатить', 'Ödə', 'Pay'],
    charged: ['Начислено', 'Hesablanıb', 'Accrued'],
    paid: ['Фактически оплачено', 'Faktiki ödənilib', 'Actually paid'],
    priorPaid: ['Ранее оплачено', 'Əvvəllər ödənilib', 'Previously paid'],
    remaining: ['Осталось по основанию', 'Əsas üzrə qalıq', 'Remaining on basis'],
    overpayment: ['Оплата сверх начисленного', 'Hesablanandan artıq ödəniş', 'Payment above accrual'],
    grossRemaining: ['Остаток по документам', 'Sənədlər üzrə qalıq', 'Remaining across documents'],
    priorCredit: [
        'Прежняя незачтённая переплата',
        'Əvvəlki bölüşdürülməmiş artıq ödəniş',
        'Prior unallocated overpayment',
    ],
    netToPay: ['Осталось оплатить', 'Ödəniləcək qalıq', 'Available to pay'],
    excess: ['Новое превышение', 'Yeni artıq məbləğ', 'New excess'],
    unknownCoverage: [
        'История оплаты не подтверждена. Остаток неизвестен.',
        'Ödəniş tarixçəsi təsdiqlənməyib. Qalıq məlum deyil.',
        'Payment history is not confirmed. The remaining amount is unknown.',
    ],
    confirmPayable: [
        'Подтвердить начисление и историю',
        'Hesablamanı və tarixçəni təsdiqlə',
        'Confirm accrual and history',
    ],
    coverageMode: ['Начальная история', 'Başlanğıc tarixçə', 'Opening history'],
    chooseCoverage: [
        'Выберите способ подтверждения',
        'Təsdiq üsulunu seçin',
        'Choose a confirmation method',
    ],
    knownZero: ['Ранее не оплачивалось', 'Əvvəllər ödəniş olmayıb', 'No previous payment'],
    originalPaid: [
        'Исходная сумма и уже оплачено',
        'İlkin məbləğ və ödənilmiş hissə',
        'Original amount and already paid',
    ],
    remainingSnapshot: [
        'Остаток долга на дату',
        'Tarix üzrə borc qalığı',
        'Remaining debt as of date',
    ],
    asOf: ['По состоянию на дату', 'Tarixə olan vəziyyət', 'As of date'],
    knownZeroAffirm: [
        'Подтверждаю, что по перечисленным начислениям ранее не было выплат',
        'Sadalanmış hesablamalar üzrə əvvəllər ödəniş olmadığını təsdiqləyirəm',
        'I confirm no previous payments for the listed accruals',
    ],
    confirmSelected: [
        'Подтвердить выбранные начисления',
        'Seçilmiş hesablamaları təsdiqlə',
        'Confirm selected accruals',
    ],
    prepareSelected: ['Подготовить черновики', 'Qaralamaları hazırla', 'Prepare drafts'],
    selectVisible: ['Выбрать показанных', 'Göstərilənləri seç', 'Select displayed'],
    amend: ['Изменить начисление', 'Hesablamanı dəyiş', 'Amend accrual'],
    newAmount: ['Новая сумма', 'Yeni məbləğ', 'New amount'],
    cancelBasis: ['Отменить основание', 'Əsası ləğv et', 'Cancel basis'],
    allocate: [
        'Распределить ранее оплаченные средства',
        'Əvvəl ödənilmiş vəsaiti bölüşdür',
        'Allocate previous payment',
    ],
    confirmAllocation: ['Подтвердить распределение', 'Bölüşdürməni təsdiqlə', 'Confirm allocation'],
    allocationMeaning: [
        'Деньги уже выданы. Остаток кассы не изменится.',
        'Pul artıq verilib. Kassanın qalığı dəyişməyəcək.',
        'Money was already paid. Cash balance will not change.',
    ],
    allocationPart: ['Часть платежа', 'Ödəniş hissəsi', 'Payment portion'],
    originalPayment: ['Исходная выплата', 'İlkin ödəniş', 'Original payment'],
    byDebt: ['По общему долгу', 'Ümumi borca görə', 'Across total debt'],
    byBasis: ['По отдельному начислению', 'Ayrıca hesablamaya görə', 'Single accrual'],
    paymentMode: ['Способ оплаты', 'Ödəniş üsulu', 'Payment mode'],
    salaryPayment: ['Выплата зарплаты', 'Əməkhaqqı ödənişi', 'Salary payment'],
    salaryAdvance: [
        'Аванс за выбранный месяц',
        'Seçilmiş ay üçün avans',
        'Advance for selected month',
    ],
    noEligibleBasis: [
        'Нет подтверждённых начислений для этой выплаты. Обратитесь к сотруднику с правом подготовки или подтверждения.',
        'Bu ödəniş üçün təsdiqlənmiş hesablama yoxdur. Hazırlama və ya təsdiq icazəsi olan əməkdaşa müraciət edin.',
        'No confirmed accrual is available for this payment. Contact a person authorized to prepare or confirm one.',
    ],
    chooseEmployee: ['Выберите сотрудника', 'Əməkdaş seçin', 'Choose employee'],
    chooseBasis: ['Выберите основание', 'Əsas seçin', 'Choose basis'],
    chooseParty: ['Выберите контрагента', 'Kontragent seçin', 'Choose counterparty'],
    ordinary: ['Разовый расход', 'Birdəfəlik xərc', 'One-off expense'],
    byAccrual: ['По начислению', 'Hesablamaya görə', 'Accrual required'],
    salaryCategory: ['Зарплата сотруднику', 'Əməkdaşa əməkhaqqı', 'Employee salary'],
    counterpartyCategory: ['Оплата контрагенту', 'Kontragentə ödəniş', 'Counterparty payment'],
    controlMode: ['Режим статьи', 'Kateqoriya rejimi', 'Category mode'],
    empty: ['Записей пока нет', 'Hələ qeyd yoxdur', 'No records yet'],
    reload: ['Загрузить актуальные данные', 'Cari məlumatları yüklə', 'Reload current data'],
    history: ['История', 'Tarixçə', 'History'],
    notes: ['Реквизиты / комментарий', 'Rekvizitlər / şərh', 'Details / note'],
    payrollPermission: ['Начисления', 'Hesablamalar', 'Accrual permissions'],
    preparePermission: ['Подготовка черновиков', 'Qaralama hazırlamaq', 'Prepare drafts'],
    confirmPermission: [
        'Подтверждение начислений и истории',
        'Hesablamaları və tarixçəni təsdiqləmək',
        'Confirm accruals and history',
    ],
    adjustPermission: [
        'Изменение подтверждённых начислений',
        'Təsdiqlənmiş hesablamaları dəyişmək',
        'Adjust confirmed accruals',
    ],
    allocatePermission: [
        'Зачёт ранее оплаченного',
        'Əvvəl ödənilmiş məbləği bölüşdürmək',
        'Allocate prior payments',
    ],
    readPermission: [
        'Просмотр доступных начислений',
        'Əlçatan hesablamaları görmək',
        'Read allowed accruals',
    ],
    staffingPermission: ['Управление штаткой', 'Ştat cədvəlini idarə etmək', 'Manage staffing'],
};
export const cashAccrualText = (locale, key) => copy[key][locale === 'az' ? 1 : locale === 'en' ? 2 : 0];
/** Messages describe proven nonmonetary results; they never imply payment approval or cash issue. */
export function cashAccrualResult(locale, type) {
    if ([
        'PAYABLE_PREPARE',
        'STAFF_BONUS_PREPARE',
        'PAYABLE_DRAFT_SAVE',
        'SALARY_PREPARE_BATCH',
        'PURCHASE_PREPARE',
        'PURCHASE_DRAFT_SAVE',
    ].includes(type))
        return cashAccrualText(locale, 'draftSaved');
    const key = {
        STAFF_POSITION_SAVE: 'position',
        STAFF_EMPLOYEE_SAVE: 'employees',
        STAFF_TERMS_CREATE: 'newTerms',
        COUNTERPARTY_SAVE: 'counterparty',
        SALARY_MONTH_CONFIRM: 'confirmed',
        PAYABLE_READY: 'confirmed',
        STAFF_BONUS_READY: 'confirmed',
        PAYABLE_CONFIRM: 'confirmed',
        SALARY_CONFIRM_BATCH: 'confirmed',
        PAYABLE_AMEND: 'amend',
        PAYABLE_ALLOCATE: 'confirmAllocation',
        CATEGORY_SEMANTIC_SAVE: 'controlMode',
    }[type];
    const prefix = key ? `${cashAccrualText(locale, key)}. ` : '';
    return (prefix +
        (locale === 'ru'
            ? 'Сохранено. Остаток кассы не изменён.'
            : locale === 'az'
                ? 'Saxlanıldı. Kassanın qalığı dəyişmədi.'
                : 'Saved. Cash balances have not changed.'));
}
export function cashAccrualEvent(locale, kind) {
    const key = {
        PREPARED: 'saveDraft',
        CONFIRMED: 'confirmed',
        AMENDED: 'amend',
        CANCELLED: 'cancelled',
        ARCHIVED: 'archived',
        ALLOCATED: 'confirmAllocation',
        PAYABLE_PREPARE: 'saveDraft',
        STAFF_BONUS_PREPARE: 'saveDraft',
        SALARY_MONTH_CONFIRM: 'confirmed',
        PAYABLE_READY: 'confirmed',
        STAFF_BONUS_READY: 'confirmed',
        PAYABLE_CONFIRM: 'confirmed',
        PAYABLE_AMEND: 'amend',
        PAYABLE_CLOSE: 'archive',
        PAYABLE_ALLOCATE: 'confirmAllocation',
        SALARY_PREPARE_BATCH: 'prepareSelected',
        SALARY_CONFIRM_BATCH: 'confirmSelected',
    }[kind];
    return key ? cashAccrualText(locale, key) : cashAccrualText(locale, 'history');
}
